<template>
    <span>
        <Input readonly v-model="cusName" search enter-button
               @on-search="handleClickCusSelect" class="w-default"></Input>
        <SkuSelectDialog :load-data-enabled="loadDataEnabled" :visible.sync="cusSelectVisible"
                   @on-select="handleCusSelect"></SkuSelectDialog>

    </span>


</template>

<script>
  import {SkuSelectDialog} from "../Dialog";

  export default {
    name: "CusInputView",
    components: {SkuSelectDialog},
    model: {
      prop: 'skuCode',
      event: 'change'
    },
    props: {
      name: {
        type: String
      },
      loadDataEnabled: {
        type: Boolean,
        default: true,
      }
    },
    watch: {
      loadDataEnabled(newVal) {
        console.log('loadDataEnabled', newVal)
      },
      cusCode(newVal) {
        if (newVal == null || newVal === '') {
          this.cusName = ''
          this.$emit('update:name', '')
        }
      },
      name(newVal) {
        if (newVal !== this.cusName) {
          this.cusName = newVal;
        }
      }
    },
    data() {
      return {
        cusSelectVisible: false,
        cusName: null
      }
    },
    methods: {
      handleCusSelect(cus) {
        this.cusSelectVisible = false
        this.cusName = cus.skuName
        this.$emit("update:name", this.cusName)
        this.$emit("change", cus.skuCode)
        // this.settle.cusCode = cus.cusCode
        this.$emit("on-success", cus)

      },
      handleClickCusSelect() {
        this.cusSelectVisible = true
      }
    }
  }
</script>

<style scoped>

</style>
